/**
 * DevExtreme (esm/__internal/ui/widget.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import Widget from "../../ui/widget/ui.widget";
var TypedWidget = Widget;
export default TypedWidget;
